export default "__VITE_ASSET__BD0eHhhk__"